module.exports = __webpack_public_path__ + "img/living_room_full.ba9042a0.jpg";